import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Slider from "react-slick";
import { Footer, Navbar } from "../components";
import ScrollToTop from "../components/ScrollToTop";

function RootLayout() {
  const location = useLocation();

  return (
    <>
      <header
        className={` ${location.pathname !== "/" ? "h-[70vh]" : "h-[100vh]"}`}
      >
        <Navbar />
        <section className="h-full relative p-0">
          {location.pathname === "/" ? (
            <div className="text-white min-w-[300px] absolute z-[1] md:translate-x-0 md:translate-y-0 text-center md:top-[45%] md:left-[7%] top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]">
              <h1 className="text-[clamp(1.7rem,3.5vw,5rem)] whitespace-nowrap font-[Aquarium] text-center md:text-left leading-[1.2] relative">
                Welcome to
                <br />
                <span className="font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-[#cca000] to-[#f5cc00]">
                  Dr. Hamdy Shehab
                </span>
                <br />
                engineering consultant
              </h1>
            </div>
          ) : (
            <div className="text-white min-w-[300px] absolute z-[1] text-center md:top-[45%] top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%]">
              <h2 className="text-[clamp(2rem,3vw,4rem)] font-[Aquarium] text-center leading-[1.2] relative">
                {location.pathname.slice(1) === "about" ||
                location.pathname.slice(1) === "contact"
                  ? location.pathname.slice(1) + " us"
                  : location.pathname
                      .slice(location.pathname.lastIndexOf("/") + 1)
                      .split("-")
                      .join(" ")}
              </h2>
            </div>
          )}
          <Slider
            className="w-full h-full overflow-hidden"
            fade={true}
            infinite={true}
            slidesToShow={1}
            autoplay={true}
            autoplaySpeed={5000}
            speed={1500}
            swipe={false}
            swipeToSlide={false}
            arrows={false}
          >
            <div className="text-center w-full h-[100vh] bg-[linear-gradient(rgba(4,9,30,0.3),rgba(4,9,30,0.3)),url('~/public/images/landing-1.webp')] bg-cover bg-center" />
            <div className="text-center w-full h-[100vh] bg-[linear-gradient(rgba(4,9,30,0.3),rgba(4,9,30,0.3)),url('~/public/images/landing-2.webp')] bg-cover bg-center" />
            <div className="text-center w-full h-[100vh] bg-[linear-gradient(rgba(4,9,30,0.3),rgba(4,9,30,0.3)),url('~/public/images/landing-3.webp')] bg-cover bg-center" />
          </Slider>
        </section>
      </header>
      <Outlet />
      <ScrollToTop />
      <Footer />
    </>
  );
}

export default RootLayout;
